module.exports = __webpack_public_path__ + "img/Img1.2568bba2.jpg";